import React from 'react';
import useAppBootstrap from 'src/hooks/useAppBootstrap';
import DashboardLayout from 'src/layouts/DashboardLayout';
import combineComponents from 'src/utils/combineComponents';
import { TemplatesProvider } from 'src/contexts/TemplatesContext';
import { AppsProvider } from 'src/contexts/AppsContext';
import { MobileAppsProvider } from 'src/contexts/MobileAppsContext';
import { JobsProvider } from 'src/contexts/JobsContext';
import { ServicesProvider } from 'src/contexts/ServicesContext';
import { LocalesProvider } from 'src/contexts/LocalesContext';
import { GuidedTourProvider } from 'src/contexts/GuidedTourContext';
import { MyApprovalsProvider } from 'src/contexts/myCollections/MyApprovalsContext';
import { MyTemplatesProvider } from 'src/contexts/myCollections/MyTemplatesContext';
import { MyAppsProvider } from 'src/contexts/myCollections/MyAppsContext';
import { MySnippetsProvider } from 'src/contexts/myCollections/MySnippetsContext';
import { SnippetsProvider } from 'src/contexts/SnippetsContext';
import { MyMobileAppsProvider } from 'src/contexts/myCollections/MyMobileAppsContext';
import withErrorBoundary from 'src/hocs/withErrorBoundary';

import UserPermissionGuard from './UserPermissionGuard';
import { PagePreloaderWithLogo } from './PagePreloader';

const providers = [
  TemplatesProvider,
  AppsProvider,
  MobileAppsProvider,
  JobsProvider,
  MyApprovalsProvider,
  ServicesProvider,
  SnippetsProvider,
  LocalesProvider,
  MyTemplatesProvider,
  MyAppsProvider,
  MyMobileAppsProvider,
  MySnippetsProvider,
  GuidedTourProvider,
  MyMobileAppsProvider
];

const ContextProviders = combineComponents(...providers);

const Bootstrap = () => {
  const isDone = useAppBootstrap();

  if (!isDone) return <PagePreloaderWithLogo />;

  return (
    <UserPermissionGuard>
      <ContextProviders>
        <DashboardLayout />
      </ContextProviders>
    </UserPermissionGuard>
  );
};

export default withErrorBoundary(Bootstrap);
